import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../../reduxService/hooks';
import { conversionLabel } from '../../../../../conversion';
import { IChannelItemProps } from './IChannelItem';
import { selectProjectInfo } from '../../../../../store/projectInfo/projectInfoSlice';

const ChannelItem = (props: IChannelItemProps) => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);
    return (
        <>
            <div className='d-flex justify-content-between'>
                <div>{t('channel_item_discharge', { unit_measure: conversionLabel.m3s_ft3s[projectInfo.data?.unitOfMeasure as number] })}</div>
                <div>{props.channel.discharge.toFixed(2)}</div>
            </div>
            <div className='d-flex justify-content-between'>
                <div>{t('channel_item_cross_area', { unit_measure: conversionLabel.m2_ft2[projectInfo.data?.unitOfMeasure as number] })}</div>
                <div>{props.channel.crossSectionalArea.toFixed(2)}</div>
            </div>
            <div className='d-flex justify-content-between'>
                <div>{t('channel_item_perimeter', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}</div>
                <div>{props.channel.wettedPerimeter.toFixed(2)}</div>
            </div>
            <div className='d-flex justify-content-between'>
                <div>{t('channel_item_radius', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}</div>
                <div>{props.channel.hydraulicRadius.toFixed(2)}</div>
            </div>
            <div className='d-flex justify-content-between'>
                <div>{t('channel_item_velocity', { unit_measure: conversionLabel.ms_fts[projectInfo.data?.unitOfMeasure as number] })}</div>
                <div>{props.channel.avarageWaterVelocity.toFixed(2)}</div>
            </div>
            <div className='d-flex justify-content-between'>
                <div>{t('channel_item_roughness')}</div>
                <div>{props.channel.avarageRoughness.toFixed(4)}</div>
            </div>
        </>
    );
};

export default ChannelItem;
